"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.personaDisplayNames = exports.personaSchema = void 0;
const zod_1 = require("zod");
exports.personaSchema = zod_1.z.enum(["projectDriver", "consultant", "consultancyLeader", "techLeader"]);
exports.personaDisplayNames = {
    projectDriver: "Project Driver",
    consultant: "Consultant",
    consultancyLeader: "Consultancy Leader",
    techLeader: "Tech Leader",
};
